import {
    Directive,
    ElementRef,
    Renderer,
    Input,
    Output,
    HostListener,
    OnChanges,
    OnDestroy,
    SimpleChange,
    EventEmitter,
    OnInit,
    NgModule
} from '@angular/core';
import { Http } from '@angular/http';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
//声明全局变量占用
declare var echarts: any;
export class EchartsDirective implements OnInit, OnChanges, OnDestroy {

     options: any;

     dataset: any[];

     theme: string;

     loading: boolean;

    // chart events:
     chartClick: EventEmitter<any> = new EventEmitter<any>();

     chartDblClick: EventEmitter<any> = new EventEmitter<any>();

     chartMouseDown: EventEmitter<any> = new EventEmitter<any>();

     chartMouseUp: EventEmitter<any> = new EventEmitter<any>();

     chartMouseOver: EventEmitter<any> = new EventEmitter<any>();

     chartMouseOut: EventEmitter<any> = new EventEmitter<any>();

     chartGlobalOut: EventEmitter<any> = new EventEmitter<any>();
public myChart: any = null;
public currentWindowWidth: any = null;
/**
 * @param {?} el
 * @param {?} renderer
 * @param {?} http
 */
constructor(public el: ElementRef,
public renderer: Renderer,
public http: Http) {
    }
/**
 * @return {?}
 */
ngOnInit(): void {
        // this.initMapData()
    }
/**
 * @return {?}
 */
public createChart() {
        this.theme = this.theme || 'default';
        this.currentWindowWidth = window.innerWidth;
        return echarts.init(this.el.nativeElement);
    }
/**
 * @return {?}
 */
initMapData() {
        this.http.get('./assets/map/china.json').subscribe(chinaJson => {
            echarts.registerMap('china', chinaJson);
        })
    }
/**
 * @return {?}
 */
public updateChart() {
        //根据类型注册地图
        let /** @type {?} */ series = this.options && this.options.series && this.options.series[0] && this.options.series[0];
        if (series['type'] === 'map') {
            let /** @type {?} */ mapType = series['mapType'];
            this.http.get(`./assets/map/${mapType}.json`).subscribe((data) => {
                const /** @type {?} */ mapJson = JSON.parse(( /** @type {?} */((<any>data)))._body);
                echarts.registerMap(mapType, mapJson);
                this.myChart.setOption(this.options);
                this.myChart.resize();
            });
        } else {
            this.myChart.setOption(this.options);
            this.myChart.resize();
        }
    }
/**
 * @param {?} event
 * @return {?}
 */
onWindowResize(event: any) {
        if (event.target.innerWidth !== this.currentWindowWidth) {
            this.currentWindowWidth = event.target.innerWidth;
            if (this.myChart) {
                this.myChart.resize();
            }
        }
    }
/**
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
        if (changes['dataset']) {
            this.onDatasetChange(this.dataset);
        }

        if (changes['options']) {
            this.onOptionsChange(this.options);
        }

        if (changes['loading']) {
            this.onLoadingChange(this.loading);
        }
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        if (this.myChart) {
            this.myChart.dispose();
            this.myChart = null;
        }
    }
/**
 * @param {?} opt
 * @return {?}
 */
public onOptionsChange(opt: any) {
        if (opt) {
            if (!this.myChart) {
                this.myChart = this.createChart();

                // register events:
                this.registerEvents(this.myChart);
            }

            if (this.hasData()) {
                this.updateChart();
            } else if (this.dataset && this.dataset.length) {
                this.mergeDataset(this.dataset);
                this.updateChart();
            }
        }
    }
/**
 * @param {?} dataset
 * @return {?}
 */
public onDatasetChange(dataset: any[]) {
        if (this.myChart && this.options) {
            if (!this.options.series) {
                this.options.series = [];
            }

            this.mergeDataset(dataset);
            this.updateChart();
        }
    }
/**
 * @param {?} loading
 * @return {?}
 */
public onLoadingChange(loading: boolean) {
        if (this.myChart) {
            if (loading) {
                this.myChart.showLoading();
            } else {
                this.myChart.hideLoading();
            }
        }
    }
/**
 * @param {?} dataset
 * @return {?}
 */
public mergeDataset(dataset: any[]) {
        for (let /** @type {?} */ i = 0, /** @type {?} */ len = dataset.length; i < len; i++) {
            if (!this.options.series[i]) {
                this.options.series[i] = { data: dataset[i] };
            } else {
                this.options.series[i].data = dataset[i];
            }
        }
    }
/**
 * method to check if the option has dataset.
 * @return {?}
 */
public hasData(): boolean {
        if (!this.options.series || !this.options.series.length) {
            return false;
        }

        for (let /** @type {?} */ serie of this.options.series) {
            if (serie.data && serie.data.length > 0) {
                return true;
            }
        }

        return false;
    }
/**
 * @param {?} myChart
 * @return {?}
 */
public registerEvents(myChart: any) {
        if (myChart) {
            // register mouse events:
            myChart.on('click', (e: any) => {
                this.chartClick.emit(e);
            });
            myChart.on('dblClick', (e: any) => {
                this.chartDblClick.emit(e);
            });
            myChart.on('mousedown', (e: any) => {
                this.chartMouseDown.emit(e);
            });
            myChart.on('mouseup', (e: any) => {
                this.chartMouseUp.emit(e);
            });
            myChart.on('mouseover', (e: any) => {
                this.chartMouseOver.emit(e);
            });
            myChart.on('mouseout', (e: any) => {
                this.chartMouseOut.emit(e);
            });
            myChart.on('globalout', (e: any) => {
                this.chartGlobalOut.emit(e);
            });
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[echarts]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer, },
{type: Http, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'options': [{ type: Input },],
'dataset': [{ type: Input },],
'theme': [{ type: Input },],
'loading': [{ type: Input },],
'chartClick': [{ type: Output },],
'chartDblClick': [{ type: Output },],
'chartMouseDown': [{ type: Output },],
'chartMouseUp': [{ type: Output },],
'chartMouseOver': [{ type: Output },],
'chartMouseOut': [{ type: Output },],
'chartGlobalOut': [{ type: Output },],
'onWindowResize': [{ type: HostListener, args: ['window:resize', ['$event'], ] },],
};
}

function EchartsDirective_tsickle_Closure_declarations() {
/** @type {?} */
EchartsDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
EchartsDirective.ctorParameters;
/** @type {?} */
EchartsDirective.propDecorators;
/** @type {?} */
EchartsDirective.prototype.options;
/** @type {?} */
EchartsDirective.prototype.dataset;
/** @type {?} */
EchartsDirective.prototype.theme;
/** @type {?} */
EchartsDirective.prototype.loading;
/** @type {?} */
EchartsDirective.prototype.chartClick;
/** @type {?} */
EchartsDirective.prototype.chartDblClick;
/** @type {?} */
EchartsDirective.prototype.chartMouseDown;
/** @type {?} */
EchartsDirective.prototype.chartMouseUp;
/** @type {?} */
EchartsDirective.prototype.chartMouseOver;
/** @type {?} */
EchartsDirective.prototype.chartMouseOut;
/** @type {?} */
EchartsDirective.prototype.chartGlobalOut;
/** @type {?} */
EchartsDirective.prototype.myChart;
/** @type {?} */
EchartsDirective.prototype.currentWindowWidth;
/** @type {?} */
EchartsDirective.prototype.el;
/** @type {?} */
EchartsDirective.prototype.renderer;
/** @type {?} */
EchartsDirective.prototype.http;
}

export class EchartsModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    declarations: [
        EchartsDirective
    ],
    exports: [EchartsDirective],
    imports: [
        CommonModule,
        FormsModule
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function EchartsModule_tsickle_Closure_declarations() {
/** @type {?} */
EchartsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
EchartsModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
